import { IDeveloperRegistry, IConfigurationRepository, IDocumentService } from "../../../domain/developer";
import { ConfigurationRepository } from "./ConfigurationRepository";
import { DocumentService } from "./DocumentService";

export class DeveloperRegistry implements IDeveloperRegistry {
  constructor(private readonly _getToken: () => string) {
  }

  getConfigurationRepository(): IConfigurationRepository {
    return new ConfigurationRepository(this._getToken);
  }

  getDocumentService(): IDocumentService {
    return new DocumentService(this._getToken);
  }
}
